import {
  Box,
  Button,
  Circle,
  Heading,
  HStack,
  Image,
  SimpleGrid,
  Stack,
  Text,
} from '@chakra-ui/react';
import WrapContent from '../components/WrapContent';

const Product = () => {
  return (
    <WrapContent>
      <SimpleGrid spacing="10" columns={[1, 1, 2]} py="40px">
        <Box>
          <Image src={'https://i.ibb.co/6DgV4sk/iphone-13-pro.jpg'} />
        </Box>
        <Stack spacing={5}>
          <Heading as="h1" fontWeight="300">
            Phone !3 Pro
          </Heading>
          <Text>
            The iPhone 13 Pro is Apple's smaller premium iPhone with a 6.1"
            screen size and for the first time in an iPhone, it comes with a
            120Hz ProMotion display for super smooth scrolling. The list of
            innovations includes a more capable triple camera setup, with a
            wide, ultra-wide and zoom cameras, as well as a LiDAR scanner.
          </Text>
          <Heading as="h2" fontWeight="400">
            500 CFX
          </Heading>
          <HStack>
            <HStack h="36px" bg="gray.300" p="1" w="fit-content" rounded="lg">
              <Text>Color : </Text>
              <Circle bg="yellow" w="30px" h="30px" />
            </HStack>
            <HStack h="36px" bg="gray.300" p="1" w="fit-content" rounded="lg">
              <Text>Screen Size : </Text>
              <Text as="b">5.8 IN </Text>
            </HStack>
          </HStack>
          <Button rounded="lg" alignSelf={'flex-start'} colorScheme={'teal'}>
            Add to Cart
          </Button>
        </Stack>
      </SimpleGrid>
    </WrapContent>
  );
};

export default Product;
